<template>
  <div class="nhbr-input">
    <b-form-group :label="label" :label-for="`input-${inputKey}`" class="text-left">
      <b-container>
        <b-row>
          <component
            :class="tooltips.hasOwnProperty(inputKey) ? `col-11` : `col-12`"
            :is="inputComponent"
            :isValidField="isValidField"
            :isRecommendedField="isRecommendedField"
            :id="`input-${inputKey}`"
            :inputType="inputType"
            :label="label"
            :inputKey="inputKey"
            @inputChanged="inputChanged"
            :options="options"
            :value="value"
          />
          <Tooltip class="col-1" v-if="tooltips.hasOwnProperty(inputKey)" :tooltipKey="inputKey"/>
        </b-row>
        <b-row v-if="!isValidField">
          <small class="validation-help-text">{{ helpText }}</small>
        </b-row>
      </b-container>

    </b-form-group>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getListValues, statistics } from '@/services/backendService'
import { getBnoCategory } from '@/utils/bnoCategoriesUtil'
import Datepicker from "vuejs-datepicker"
import { hu } from 'vuejs-datepicker/dist/locale'

import TextInput from '@/components/inputTypes/TextInput'
import DropdownSelect from '@/components/inputTypes/DropdownSelect'
import DateSelector from '@/components/inputTypes/DateSelector'
import DropdownWithSearch from '@/components/inputTypes/DropdownWithSearch'
import LaborInput from '@/components/inputTypes/LaborInput'

import Tooltip from '@/components/Tooltip.vue'
import tooltips from '@/utils/tooltipsUtil.js'

import _ from 'lodash'

export default {
  name: 'nhbr-input',
  components: {
    TextInput,
    DropdownSelect,
    DateSelector,
    LaborInput,
    Tooltip
  },
  computed: {
    ...mapState(['formInputs']),
    inputComponent() {
      switch(this.inputType) {
      case 'text':
        return TextInput
      case 'number':
        return TextInput
      case 'three_state':
        return DropdownSelect
      case 'list':
        return DropdownSelect
      case 'search_list':
        return DropdownWithSearch
      case 'date':
        return DateSelector
      case 'labor':
        return LaborInput
      }
      return TextInput
    },
  },
  data() {
    return {
      threeStateOptions: [
        { value: null, text: '' },
        { value: 1, text: 'Nem ismert' },
        { value: 2, text: 'Igen' },
        { value: 3, text: 'Nem' }
      ],
      options: [],
      dateLocalisation: hu,
      dateStart: null,
      tooltips,
      lodash: _
    }
  },
  props: {
    inputKey: {
      type: String,
      required: true
    },
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Object,
      required: false,
      default: null
    },
    helpText: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    isValidField: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | Object,
      required: false,
      default: true
    },
    inputType: {
      type: String,
      required: false,
      default: 'text'
    },
    isRecommendedField: {
      type: Boolean,
      required: false,
      default: false
    },
    getValueFromBackend: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    ...mapActions(['setFormInput']),
    inputChanged(event) {
      this.setFormInput({
        key: this.inputKey,
        value: event !== null && event.length === 0 ? null : event
      })
    },
    getListValues() {
      let endpoint = this.inputKey
      if (this.inputKey === 'who' && this.formInputs['bno']) {
        endpoint += '/' + getBnoCategory(this.formInputs['bno'])
      }

      getListValues(endpoint).then(listValuesData => {
        let retArray = [
          {
            value: null,
            text: '',
          }
        ]
        let listValues = listValuesData.data.map(item => {
          let prefix = this.lodash.get(item, 'kategoria', this.lodash.get(item, 'kod', ''))

          if (prefix.length > 0) {
            prefix = '[' + prefix + '] '
          }

          return {
            value: item.kod,
            text:  prefix + item.elnevezes
          }
        })
        this.options = [...retArray, ...listValues]
      })
    }
  },
  mounted() {
    if ((this.inputType === 'list' || this.inputType === 'search_list') && this.getValueFromBackend) {
      this.getListValues()
    } else if (this.inputType === 'three_state') {
      this.options = this.threeStateOptions
    }
  },
  watch: {
    'formInputs.bno': {
      handler: function() {
        if (this.inputKey === 'who') {
          this.getListValues()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
/*** Component Style ***/
.nhbr-input {
  position: relative;
  // width: 400px;
}

.validation-help-text {
  color: #dc3545;
  padding-left: 16px;
  margin-top: 8px;
}
</style>
